import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-links">
          <a href="https://www.linkedin.com/in/ahmadrgharib/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
          <a href="https://github.com/ahmadrgharib" target="_blank" rel="noreferrer" aria-label="GitHub">
            <GitHubIcon />
          </a>
          <a href="https://www.upwork.com/freelancers/~012aecb8a29fb8b721" target="_blank" rel="noreferrer" aria-label="Upwork">
            <svg viewBox="0 0 24 24" fill="currentColor" width="1.3rem" height="1.3rem" aria-hidden="true">
              <path d="M18.375 9.556c-1.64 0-2.916.96-3.455 2.373l-1.234-5.04H11.25v6.416c0 1.013-.82 1.834-1.833 1.834s-1.834-.821-1.834-1.834V6.889H5.147v5.416c0 2.17 1.76 3.929 3.93 3.929 2.169 0 3.928-1.76 3.928-3.93v-.906c.48 1.61 1.88 2.836 3.37 2.836 2.17 0 3.93-1.76 3.93-3.929 0-2.17-1.76-3.75-1.93-3.75zm0 5.512c-.96 0-1.75-.79-1.75-1.762 0-.973.79-1.762 1.75-1.762.96 0 1.75.789 1.75 1.762 0 .972-.79 1.762-1.75 1.762z"/>
            </svg>
          </a>
        </div>
        <p className="footer-tagline">Always learning. Always building.</p>
        <p className="footer-copy">© {new Date().getFullYear()} Ahmad Gharib</p>
      </div>
    </footer>
  );
}

export default Footer;
